import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CalendarDays } from 'lucide-react';
import { Button } from './ui/button';
import { Reveal } from './SectionHeading';
import { CONTACT } from '../data/siteData';

export const CTABand = ({ title = 'Ready to Scale Your Operations?', subtitle = 'Book a free consultation and get a tailored workforce plan within one business day.' }) => (
  <section data-testid="cta-band" className="py-16 md:py-24 bg-[#0A192F] relative overflow-hidden">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(0,102,204,0.18),transparent_60%)]" />
    <Reveal className="relative max-w-4xl mx-auto px-6 text-center">
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-white font-heading leading-snug">{title}</h2>
      <p className="mt-4 text-slate-400 text-base max-w-xl mx-auto">{subtitle}</p>
      <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
        <Button asChild size="lg" data-testid="cta-band-book" className="bg-[#0066CC] hover:bg-[#0052A3] text-white px-8 group">
          <a href={CONTACT.calendly} target="_blank" rel="noopener noreferrer">
            <CalendarDays className="mr-2 w-4 h-4" /> Book a Consultation
          </a>
        </Button>
        <Button asChild size="lg" variant="outline" data-testid="cta-band-contact" className="border-white/25 bg-white/5 text-white hover:bg-white/10 hover:text-white px-8 group">
          <Link to="/#contact">
            Request a Call <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Button>
      </div>
    </Reveal>
  </section>
);
